import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from "react-redux"
import { PropTypes } from 'prop-types'
import { Row, Col, FormGroup, Panel, Button, Label, Badge } from "react-bootstrap"
import moment from 'moment'
import axios from 'axios'
import ContentWrapper from "../../components/layout/ContentWrapper"
import { URL } from '../../config'
import { lblattrs2 } from '../../utils/style'
import { red, blue } from '../../utils/constants'
import { runRankings } from "../../redux/actions/action_season"

class LastRun extends React.Component {
	static propTypes = {
		history: PropTypes.object,
		oidc: PropTypes.object,
		runRankings: PropTypes.func
	}
	constructor(props) {
		super(props)
		this.state = {
			title: 'Last Run Details',
			status: '',
			startDate: '',
			numberOfEvents: '',
            week: '',
            //published: '',
            //publishDate: '',
			rankingTriggered: false,
			runningRanking: false
		}
		this.getLastRankingRun = this.getLastRankingRun.bind(this)
		this.handleViewRanking = this.handleViewRanking.bind(this)
		this.handleRunRanking = this.handleRunRanking.bind(this)
	}

	componentDidMount() {
		this.getLastRankingRun()
	}
	handleRunRanking() {
		const { season } = this.state;
		this.setState({ runningRanking: true, rankingTriggered: false })

		const token = this.props.oidc.user.access_token;
		this.props.runRankings(season - 1, token);

		this.setState({
			rankingTriggered: true,
			runningRanking: false
		});
	}
	getLastRankingRun() {
		const rankingrunendpoint = '/lastrankingrun'
		const seasonURL = `${URL.season}${rankingrunendpoint}`

		axios.get(seasonURL)
			.then(response => {

				if (response.data) {
					const { startDate, season, week, numberOfEvents, status } = response.data
					this.setState({
						startDate,
						season,
						week,
						numberOfEvents,
                        status
                        //published,
                        //publishDate
					})
				}
			})
	}
	handleViewRanking() {
		this.props.history.push('/ranking')
	}
	render() {
		const {
			status,
			startDate,
			numberOfEvents,
			season,
      week,
      //published,
      //publishDate,
			rankingTriggered,
			runningRanking
		} = this.state

		const reRunIcon = runningRanking ? "fa fa-spinner fa-spin" : "fa fa-bolt"

		return (

			<ContentWrapper>
				<Row>
					<Col sm={6} >
						<h4>{this.state.title}</h4>
						<Panel sm={6} style={{ marginTop: '30px' }}>
							<form className="form-horizontal" sm={8}>
								<FormGroup>
									<label className={lblattrs2}>Status:</label>
									<Col sm={8} md={5} lg={5}>
										<h4 style={{ marginTop: '5px' }}><Label bsStyle="success"><Badge />{status ? status.toUpperCase() : 'N/A'}</Label></h4>
									</Col>
								</FormGroup>
								<FormGroup>
									<label className={lblattrs2}>Date:</label>
									<Col sm={9}>
										<label className="form-control" style={{ borderWidth: '0px' }}>{moment(startDate).format('LLLL')} CST</label>
									</Col>
								</FormGroup>
								<FormGroup>
									<label className={lblattrs2}>Season:</label>
									<Col sm={8} md={5} lg={5}>
										<label className="form-control" style={{ borderWidth: '0px' }}>{season}</label>
									</Col>
								</FormGroup>
								<FormGroup>
									<label className={lblattrs2}>Week:</label>
									<Col sm={8} md={5} lg={5}>
										<label className="form-control" style={{ borderWidth: '0px' }}>{week}</label>
									</Col>
								</FormGroup>

								<FormGroup>
									<label className={lblattrs2}>Events:</label>
									<Col sm={8} md={5} lg={5}>
										<label className="form-control" style={{ borderWidth: '0px' }}><Badge style={{ backgroundColor: '#3b5998' }}>{numberOfEvents}</Badge></label>
									</Col>
								</FormGroup>
								<FormGroup>
									<Col sm={12} >
										<Button style={{ color: red, minWidth: '90px', paddingLeft: '10px' }} onClick={this.handleRunRanking}>
											<i className={reRunIcon} aria-hidden="true" />{' '}&nbsp;Rerun Rankings
										</Button>{' '}
										<Button style={{ color: blue, minWidth: '95px', paddingLeft: '2%' }} onClick={this.handleViewRanking}>
											<i className="fa fa-trophy" aria-hidden="true" />&nbsp;&nbsp;View Ranking
										</Button>{' '}
										{/* 	<Button  style={{ color:warning,minWidth:'100px',paddingLeft:'2%' }}>
												<i className="fa fa-question" aria-hidden="true" />&nbsp;&nbsp;What If?
										</Button> */}
									</Col>
								</FormGroup>
							</form>
							{
								rankingTriggered &&
								(
									<div sm={12}>
										<i className="fa fa-info-circle" style={{ color: blue }} aria-hidden="true" />&nbsp;&nbsp;
										The ranking process has been triggered. This may take several minutes (1-5 minutes) to complete.
									</div>
								)
							}
						</Panel>
                    </Col>
                    {/*<Col sm={6} >*/}
                    {/*  <h4>Last Publish Details</h4>*/}
                    {/*  <Panel sm={6} style={{ marginTop: '30px' }}>*/}
                    {/*    <form className="form-horizontal" sm={8}>*/}
                    {/*      <FormGroup>*/}
                    {/*        <label className={lblattrs2}>Status:</label>*/}
                    {/*        <Col sm={8} md={5} lg={5}>*/}
                    {/*          <h4 style={{ marginTop: '5px' }}><Label bsStyle="success"><Badge />{published ? published.toUpperCase() : 'N/A'}</Label></h4>*/}
                    {/*        </Col>*/}
                    {/*      </FormGroup>*/}
                    {/*      <FormGroup>*/}
                    {/*        <label className={lblattrs2}>Date:</label>*/}
                    {/*        <Col sm={9}>*/}
                    {/*          <label className="form-control" style={{ borderWidth: '0px' }}>{moment(publishDate).format('LLLL')} CST</label>*/}
                    {/*        </Col>*/}
                    {/*      </FormGroup>*/}
                    {/*      <FormGroup>*/}
                    {/*        <label className={lblattrs2}>Season:</label>*/}
                    {/*        <Col sm={8} md={5} lg={5}>*/}
                    {/*          <label className="form-control" style={{ borderWidth: '0px' }}>{season}</label>*/}
                    {/*        </Col>*/}
                    {/*      </FormGroup>*/}
                    {/*      <FormGroup>*/}
                    {/*        <label className={lblattrs2}>Week:</label>*/}
                    {/*        <Col sm={8} md={5} lg={5}>*/}
                    {/*          <label className="form-control" style={{ borderWidth: '0px' }}>{week}</label>*/}
                    {/*        </Col>*/}
                    {/*      </FormGroup>*/}

                    {/*      <FormGroup>*/}
                    {/*        <label className={lblattrs2}>Events:</label>*/}
                    {/*        <Col sm={8} md={5} lg={5}>*/}
                    {/*          <label className="form-control" style={{ borderWidth: '0px' }}><Badge style={{ backgroundColor: '#3b5998' }}>{numberOfEvents}</Badge></label>*/}
                    {/*        </Col>*/}
                    {/*      </FormGroup>*/}
                    {/*    </form>*/}
                    {/*  </Panel>*/}
                    {/*</Col>*/}

				</Row>
			</ContentWrapper>)

	}
}

function mapStateToProps(state) {
	return { oidc: { ...state.oidc } }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ runRankings }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LastRun)


// WEBPACK FOOTER //
// ./src/containers/ranking/LastRun.js